import { useEffect, useState } from "react";
import axios from "axios";
import { Card, Col, Row } from "react-bootstrap";
import { Globe } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import Footer from "../Footer/Footer";
import InvoiceDetailMedia from "../InvoiceDetail/InvoiceDetailMedia";
import Loader from "../Loader/Loader";
import HelperService from "../utility/HelperService";
import WebService from "../utility/WebService";
import phoneIcon from "../assets/images/phone.svg";
import mailIcon from "../assets/images/mail.svg";
import "../InvoiceDetail/Invoice.scss";
import "./WorkOrderDetails.scss";

const WorkOrderDetails = () => {
    const [isLoading, setLoading] = useState(false);
    const [isShown, setShown] = useState(false);
    const [workOrderData, setWorkOrderData] = useState<any>({});
    const [otherData, setOtherData] = useState<any>({});
    const token = encodeURIComponent(new URLSearchParams(window.location.search).get("token") || "");

    useEffect(() => {
        if (!token) {
            return;
        }

        localStorage.clear();
        setLoading(true);
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken?id=${token}`)
            .then((response: any) => {
                if (response.data.status === "Error") {
                    toast.error(response.data.message);
                    return;
                }

                const accessToken = response.data.accessToken;
                const workOrderNumber = response.data.workOrderNumber || response.data.workOrderNo || response.data.invoiceNumber;
                if (!accessToken || !workOrderNumber) {
                    return;
                }

                localStorage.setItem("token", accessToken);
                localStorage.setItem("tenant_url", response.data.tenantUrl);
                setOtherData(response.data);
                return getWorkOrderData(accessToken, response.data.companyCode, workOrderNumber, response.data.tenantUrl);
            })
            .catch(() => undefined)
            .finally(() => setLoading(false));
    }, [token]);

    const getWorkOrderData = (accessToken: string, companyCode: string, workOrderNumber: string, tenantUrl: string) => {
        return axios.get(
            `${tenantUrl}/api/Invoice/customerInvoiceInfo?CompanyCode=${companyCode}&InvoiceNumber=${workOrderNumber}&InitialLoad=true`,
            { headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` } }
        )
            .then((response: any) => {
                if (response.data?.data) {
                    setWorkOrderData(response.data.data);
                    setShown(true);
                }
            })
            .catch(() => undefined)
            .finally(() => setLoading(false));
    };

    const callInfo = workOrderData.callInfo || workOrderData.workOrderInfo || {};
    const workOrderNumber = callInfo.woNum || callInfo.workOrderNum || callInfo.workOrderNumber || callInfo.workOrderNo || otherData.workOrderNumber || otherData.workOrderNo || otherData.invoiceNumber;
    const workDescription = callInfo.workDescription || callInfo.workDesc || callInfo.description || workOrderData.workDescription;

    return <>
        <Loader show={isLoading} />
        <div className="header">
            <div className="work-order-header"><div className="invoice-title">Work Order</div></div>
        </div>
        {isShown && <div className="work-order-details p-1" style={{ backgroundColor: "#E0E0E0" }}>
            <Card className="content-card card-shadow p-0">
                <Card.Body className="py-2 text-dark">
                    <Row className="pt-1">
                        {otherData.genericLogoUrl && <Col md={3}>
                            <img src={otherData.genericLogoUrl} width="80%" height={130} style={{ objectFit: "contain", marginLeft: "2%", padding: 0 }} alt="Company logo" />
                        </Col>}
                        <Col md={otherData.genericLogoUrl ? 4 : 6}>
                            <div className="mb-0 font-w-medium font-15">Company Info</div>
                            {workOrderData.companyInfo?.companyName && <div className="address-text">{workOrderData.companyInfo.companyName}</div>}
                            {workOrderData.companyInfo?.companyAddr1 && <div className="address-text">{workOrderData.companyInfo.companyAddr1}</div>}
                            {workOrderData.companyInfo?.companyAddr2 && <div className="address-text">{workOrderData.companyInfo.companyAddr2}</div>}
                            {workOrderData.companyInfo?.companyCity && <div className="address-text">{workOrderData.companyInfo.companyCity}{workOrderData.companyInfo.companyState && `, ${workOrderData.companyInfo.companyState}`}{workOrderData.companyInfo.companyZip && `, ${workOrderData.companyInfo.companyZip}`}</div>}
                            {workOrderData.companyInfo?.compPhone && <div className="address-text"><img src={phoneIcon} className="me-2" alt="" />{HelperService.getFormattedContact(workOrderData.companyInfo.compPhone)}</div>}
                            {workOrderData.companyInfo?.compEmail && <div className="address-text"><img src={mailIcon} className="me-2" alt="" />{workOrderData.companyInfo.compEmail}</div>}
                            {workOrderData.companyInfo?.compWebAddress && <div className="address-text"><Globe className="me-2" />{workOrderData.companyInfo.compWebAddress}</div>}
                        </Col>
                        <Col md={otherData.genericLogoUrl ? 5 : 6}>
                            <div className="d-flex align-items-baseline mb-0">
                                <div className="font-w-medium font-15">Location {workOrderData.location?.smNum}</div>
                                <div className="work-order-number font-w-medium font-15">Work Order #</div>
                                <div className="ms-2 address-text">{workOrderNumber || "-"}</div>
                            </div>
                            {workOrderData.location?.smName && <div className="address-text">{workOrderData.location.smName}</div>}
                            {workOrderData.location?.address1 && <div className="address-text">{workOrderData.location.address1}</div>}
                            {workOrderData.location?.address2 && <div className="address-text">{workOrderData.location.address2}</div>}
                            {workOrderData.location?.city && <div className="address-text">{workOrderData.location.city}{workOrderData.location.state && `, ${workOrderData.location.state}`}{workOrderData.location.zip && `, ${workOrderData.location.zip}`}</div>}
                            {workOrderData.location?.smPhone && <div className="address-text"><img src={phoneIcon} className="me-2" alt="" />{HelperService.getFormattedContact(workOrderData.location.smPhone)}</div>}
                            {workOrderData.location?.defaultEMail && <div className="address-text"><img src={mailIcon} className="me-2" alt="" />{workOrderData.location.defaultEMail}</div>}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="content-card card-shadow p-0 mt-1">
                <Card.Body className="py-2 text-dark">
                    <div className="font-w-medium font-15">Call For Reason</div>
                    <div className="address-text">{callInfo.reasonForCall || "-"}</div>
                </Card.Body>
            </Card>
            <Card className="content-card card-shadow p-0 mt-1">
                <Card.Body className="py-2 text-dark">
                    <div className="font-w-medium font-15">Work Description</div>
                    <div className="address-text">{workDescription || "-"}</div>
                </Card.Body>
            </Card>
            <div className="mt-1">
                <InvoiceDetailMedia title="Media" data={workOrderData.mediaFiles || workOrderData.media || []} />
            </div>
        </div>}
        {!isLoading && !isShown && !token && <div className="no-invoice-view"><span className="no-invoice">No Work Order Found!</span></div>}
        <Footer data={otherData.genericFooter} />
    </>;
};

export default WorkOrderDetails;